<template>
  <div class="claim-report-card">
    <div
      class="p-4"
      @mouseover="setHovered(true)"
      @mouseleave="setHovered(false)"
      :class="{ 'card-hovered': hovered }"
      @click="setEdit()"
    >
      <div v-show="hovered" class="hovered-area-container"></div>
      <slot name="title"></slot>
      <div v-show="!isEditing">
        <slot name="contents"></slot>
      </div>
      <div v-show="isEditing">
        <slot name="editing"></slot>
      </div>
    </div>
    <vs-divider class="m-0"></vs-divider>
  </div>
</template>

<script>

export default {
  name: "M.CommonClaimReportCard",
  props: {
  },
  data() {
    return {
      isEditing: false,
      hovered: false,
    }
  },

  methods: {
    setHovered(value) {
      if (this.isEditing) return false;
      this.hovered = value;
    },
    setEdit() {
      this.isEditing = true;
      this.hovered = false;
    },
    cancelEdit() {
      this.isEditing = false;
    },
  }



}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

.claim-report-card {
  font-family: $aisea-font-family;

  .card-hovered {
    background-color: rgba($aisea-blue, 0.1);
  }

  .hovered-area-container {
    background-color: #ff33;
    position: relative;
    width: 100%;
    height: 100%;
    .hovered-area {
      position: absolute;
      background-color: #f333;
      width: 100%;
      height: 100%;
    }

    .hovered-text {
      width: 100%;
      height: 100%;
      color: $aisea-blue;
      font-weight: bold;
    }
  }

  .title {
    font-weight: bold;
  }
  .required {
    color: $aisea-red;
  }
  .updated-date-label {
    font-size: 12px;
  }
}
</style>